import { ModalProps, Modal as AntModal } from "antd";
import React from "react";
import useQueryParams from "../../hooks/useQueryParams";
import styles from './NewMadalR.module.css'
export interface IModalProps extends ModalProps {
  matcher: string;
  removeParamsOnClose?: string[];
  isSaleModal?: boolean
}

const Modal: React.FC<IModalProps> = ({
  children,
  matcher,
  removeParamsOnClose = [],
  isSaleModal,
  ...props
}) => {

  const query = useQueryParams();
  return (
    <AntModal
      destroyOnClose
      {...props}
      visible={query.has(matcher)}
      onCancel={() => query.removeMany(matcher, ...removeParamsOnClose)}
      className={isSaleModal ? styles.Madal : ''}
      >
      {children}
    </AntModal>
  );
};

export default Modal;
